module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Chapter Two")])])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterDateline",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "0%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("December")])])])]), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_vm._v("With eight months of hard-fought sobriety inside him to filter his thoughts, Edward managed to keep a wiseacre response to himself as the teen with the bright smile behind the cash register chirped, “Merry Christmas!” and handed him his bags of groceries.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Thank you for shopping with us, sir,” the girl went on, either genuinely caught up in the goodwill of the season or intent in her desire to impress her supervisor. Said supervisor, sporting a bit more weariness to his frozen smile, was pacing the bustling check-out lines, ensuring every customer had a positive shopping experience and would return to buy holiday turkeys and hams and whatever last-minute presents they might need in the upcoming two weeks.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("At the girl’s tender age, Edward suspected it was the former. He tucked his billfold into the back pocket of his jeans and unhooked his cane from the edge of the counter before grabbing the two plastic bags. He sincerely hoped the young cashier would be way past his thirty-five years of age before learning to hate the cheer and dazzle and social expectations of the holidays as much as he did.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The economy might thrive on the holiday season. A few Pollyannas might. But Edward Kincaid did not.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("For him, Christmas meant violence and loss and a lifetime of happiness and purpose he might never find again.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Merry Christmas, sir.” The supervisor’s greeting echoed the cashier’s as Edward limped past.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His memory played a sweet lispy voice inside his head. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("“Merry Christmas, Daddy. Did you get my bike?”")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("“I did. A purple one. Merry Christmas, baby.”")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He blinked, as if a physical jerk could shut off the nightmare of those last few moments of his daughter’s life. If he never said those words again, it would be too soon.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Clamping down on the bile of regret that rose in his throat, Edward acknowledged the man with a nod and walked out the sliding door, turning his face to the biting wind of a Missouri winter. He relished the icy crystals in the air, stinging his face and neck. Winter had come early to Kansas City this year. Snow had been on the ground for three weeks now, long enough to pack into drifts against buildings and trees and for grading salt and traffic to coat the pavement with a slick, slushy glop. The moisture beading on his charcoal sweater and the unzipped black coat he wore indicated another layer of this snowy mess was on the way. The dropping temperature that seemed to settle in his mended joints confirmed it.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Edward plunged the tip of his cane into the slush beside the curb, feeling even that tiny step down like the jab of a pin in his right ankle and knee. The twinges in his rebuilt body were tolerable most days. According to the doctors who’d stitched him back together, he was as healed as he was going to get. Now it was just a matter of building strength and continuing with his physical therapy exercises to maintain flexibility. His youngest brother, Holden, had insisted on giving him his weight-training set when he’d upgraded to newer equipment. Months of PT had made Edward fit. Dragging himself to the weight bench every time the need for a drink tried to take hold was getting him back into fighting shape. With the idea in mind that he’d wind up an arthritic old man before his time if he didn’t keep moving, Edward stretched his legs out to lengthen his stride and crossed the parking lot to his black SUV.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He’d just tossed the grocery sacks into the back seat of the Grand Cherokee when the cell phone on his belt hummed with an incoming call. He climbed in behind the wheel, tossed his cane over to the passenger side and started the vehicle’s powerful engine before unclipping the phone and checking the number. It was his youngest brother, Holden.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Edward cranked the defroster and opened the phone with a grin. “What do you want?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Bah, humbug to you, too.” Holden’s deep-pitched voice was laced with equal parts teasing and reprimand. “Where are you?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Watching the first crystalline flakes dot his windshield and then melt away, Edward arched a dark brow with knowing sarcasm. Baby Bro wanted something. “I’m sitting in the grocery store parking lot, trying to get comfortable in my new car. You know, I had my old Jeep all broken in before you borrowed it and returned it a totaled mess after your jaunt down to the Ozarks with your girlfriend. This new model the insurance paid for doesn’t feel like home yet. It still has that new upholstery smell.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Um, hello? Witness protection? Bullets flying? You’re lucky "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("I")])]), _vm._v(" didn’t come back totaled.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Damn lucky. Despite Holden’s sharpshooter and survival training with KCPD’s S.W.A.T. team—and the loan of Edward’s vehicle and expertise in hiding out from the world—he’d barely managed to stay a step ahead of the assassin who’d targeted the woman who’d witnessed their father’s murder. Liza Parrish would probably be dead right now if Holden hadn’t stepped up to volunteer as her personal bodyguard. Along with Sawyer’s discovery of a dangerous conspiracy, and evidence that provided motive and a list of suspects that Atticus had uncovered, Liza’s testimony had given KCPD a good description of their father’s murderer or murderers.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Eight months had passed since John Kincaid’s beaten body had been found slain, execution-style, in an abandoned riverfront warehouse. Edward’s years of experience on the force warned him that the longer it took to solve the case, the harder it would be to find the answers they needed. But soon, very soon, KCPD would put someone behind bars for the vicious crime and justice would finally be served.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("If the Kincaid brothers had anything to do with it.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Three of them, at any rate. He was willing enough to help out where he could, but it had been a long time since Edward had picked up his gun and badge. If he could remain on the sidelines, it was probably just as well. His last few days as a full-fledged cop hadn’t done the people he cared about any good.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Pushing aside a niggling thought that was part relief, part regret and all guilt, Edward turned his focus back to his brother’s call. “I guess I’d rather have you around instead of that old Jeep.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You sweet talker, you.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Right. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("I love you")])]), _vm._v(" came about as easily to his lips as "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Merry Christmas")])]), _vm._v(". Holden understood.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“So, what’s up?” Edward asked, noting how the snow gathering in the clouds above had turned the afternoon into a hazy twilight.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I want you to come to Christmas Eve dinner at Mom’s house.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Little Brother didn’t beat around the bush, did he.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Though the idea of a family get-together, with presents and ornaments and food and laughter and love, hit him like a blinding sucker punch, Edward buried his knee-jerk reaction beneath the sarcasm that laced his voice. “I’m busy on the twenty-fourth.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Bull—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Watch your mouth, little brother.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“When are you going to move on, Edward?” Holden asked, managing to sound irritated and concerned at the same time.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’m working on it.” Edward idly looked out the window to see people hunched down in their coats and scarves against the weather, their arms laden with sacks and packages, purses and briefcases—all going somewhere with a purpose. He used to be driven like that. Catch some bad guys, save the day. Hurry home to make love to his wife and play kickball or tag or read a book with his daughter. Since their deaths, it had taken him four months to get out of the hospital and learn to walk again, the rest of the year to move out of his house to a cabin in the countryside outside of K.C.—to settle in a quiet place where the memories couldn’t find him. It had taken longer still before a visit from his family or a trip to the store didn’t drain every last ounce of his emotional energy. “I’m working on it,” he repeated.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I know you’ve come a long way. But…please. This will be Mom’s first Christmas without Dad. I think we should all be there for her. I think we all need to be together.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("So, when did the youngest of Edward’s brothers start to sound like the wise old man of the family?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I don’t want to ruin anyone’s holiday with one of my moods.” He groused a curse beneath his breath. “Staying away might be the best gift I could give Mom.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Nobody believes that but you, big brother.” Holden’s voice brightened, changing the tone if not the topic. “We’d love it if you’d come, even if it’s just for a little while. Liza and I have an announcement to make.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Surprise, surprise. Are you finally gonna make an honest woman of her?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Finally? Give me a break, Dr. Romance. I was in the hospital recovering from a sucking chest wound and a concussion after our run-in with Z Group’s assassin, Mr. Smith.” Holden’s news didn’t surprise him. With a hit man relentlessly trying to silence Liza’s testimony about their father’s murder, falling in love had happened fast. But even Edward’s cynical soul had been able to see the depth of what was between them. “Then we had to find a new place for Liza that had room for three dogs after her house got all shot up. Those are all legitimate excuses for delaying wedding plans with the woman you love.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Got that out of an etiquette book, did you?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But Holden wouldn’t be dissuaded. “So, are you coming to Mom’s or not?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“She knows I love her.” He deserved a little flak for dropping out of the family—out of life—for so long. But he was making an effort—improving his family relationships, day by day. The rest of the world would have to wait to get his charming self back into the thick of things. “I’m a lot better about calling her than I was even a few months ago. Talked to her last night, in fact. I know she’s planning a quiet family kind of thing—Sawyer with his wife and son and mother-in-law, Atticus and Brooke with her aunts, you and Liza, Uncle Bill.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You’re on the guest list, too. Even if you’re just there for a…”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("For a what? Edward whistled a long breath between his lips, feeling, not for the first time, the pain his addiction had cost his family. “A toast?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Sawyer’s wife, Mel, is pregnant, so she won’t be drinking any alcohol, either. Maybe none of us will. You know how Mom likes that sparkling cider.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Relax, little brother. Mentioning booze is not going to make me go out and have a drink.” There were a dozen other things that might tempt him to go back inside the store for a six-pack, but the mere mention of alcohol wasn’t one of them. “I’m okay. I’ll…think about the Christmas Eve thing.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You’ve already decided not to come, haven’t you.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Maybe I can stop by on another day.” And he "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("would")])]), _vm._v(" make the effort to do so. It was one thing for him to suffer through the season, but now that he was sober, he knew there was no good reason for his family to hurt any more than they had to. “Congratulations to you and Liza, though. I promise not to tell anyone until you make a formal announcement.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’ve got eight days to change your mind. I’m not giving up.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Didn’t think you would.” The interior of the new Jeep had warmed up enough that Edward tucked the phone between his shoulder and ear and pulled off his black leather gloves. “Now, do you have some other reason for calling besides pestering me about family reunions?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I might.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Come on. I’ve been sitting here long enough that it’s snowing again. So spit it out.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Though he normally went out on calls with his S.W.A.T. team, Holden had been assigned to temporary light duty—aka sitting behind a desk—since going back to work at the Fourth Precinct after his hospital stay and recovery time. Edward could hear some papers rustling in the background as Holden’s voice dropped to barely more than a whisper. “We’ve come up with a lead on Dad’s murder that we—Sawyer, Atticus, Kevin Grove—the lead detective on the case—and me—believe we need "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("your")])]), _vm._v(" help to follow up on.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Me? I’ve got until January second to let Major Taylor know whether or not I’m coming back to KCPD. Until then, I’m off duty. I don’t even carry my badge anymore.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Exactly. You may have street connections that we could use beyond the standard pawn shops and fences.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Edward had worked overt and undercover drug enforcement for most of his KCPD career. Once he’d had connections on both sides of the law. But since plowing André Butler beneath the wheels of his SUV, Edward hadn’t gone near any of his old “friends.” “You want me to do something illegal? Conduct a search without an official warrant?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“All I want is for you to help us look for a ring. And maybe a couple of disintegrating bullets.”")])]), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span')]), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_vm._v("“D"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("ASHING THROUGH THE SNOW")])]), _vm._v("…”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Holly Masterson’s singing softened to a hum as she squinted at her computer screen and typed in the next line of her autopsy report. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("COD—Natural Causes. Massive heart failure due to…")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“In a one-horse open sleigh…”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her fingers danced over the keyboard in time to the music playing over her earphones. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Indigent lifestyle of malnutrition, exposure to elements and lack of medical…")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“…laughing all the way. Ha, ha, ha. Bells on—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The red light flashed on her office phone, indicating an incoming call. Holly killed the music as she saved her report. She spared a few moments to back it up to a disk and send it to the printer before pulling off her earphones and answering the call. “Crime lab. Dr. Masterson speaking.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Do I really have to call you "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Doctor?")])]), _vm._v(" Can’t I just call you Squirt, the way I used to?” Holly grinned at the teasing in her older brother Eli’s voice. “So, what’s keeping you at the lab so late tonight? I tried to call you on your cell, but it went straight to voice mail.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("After a half dozen calls from the same unnamed cell phone, with no one on the other end when she picked it up, Holly had turned hers off and plugged it into its charger. But she had helped Eli raise herself and their younger sister since she was in high school and their parents had died in a plane crash. They’d weathered their sister’s rebellious choices and cocaine addiction together. A wrong number was nothing to worry an overprotective big brother about.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I like to call it ‘work’,” Holly deadpanned. “You know I man the late shift at the lab, or you wouldn’t be calling me this close to midnight. So what’s up?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“A guy can’t call his sister just to see how she’s doing?” That dry wit was a Masterson trait. “So…your car’s running all right? You got the stopper on that bathroom drain fixed? You’re not dating anyone I need to check out?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Yes. I’ll get to it. And no.” Holly grinned. “So, what’s going on that’s so important you needed to stay up past your bedtime and chat before our regular Friday lunch?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Several minutes later, Holly was pacing in front of the windows that separated her office from the darkened lab and the autopsy room beyond. This close to the holidays, the crime lab ran a skeleton crew at night. Other than the derelict John Doe lying in the morgue, Holly was alone in the basement. She knew lab techs on the floors above her were monitoring ongoing fiber trace tests and editing background noise off some security camera footage. And she was having one of her own team members rerun a ballistics test on what she’d dubbed a disintegrating bullet—a mysterious new design of deadly ammunition that had shown up in several autopsies this year. Unfortunately, even by the time she’d discovered them inside the murder victims, the bullets had already begun to decompose, making it impossible to read striations and trace them back to the gun that fired it. They’d be lucky if her ballistics specialist, Rick Temple, could determine the manufacturer and caliber of the bullet.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But that was all backlog work. Without any pressing case demands, Holly herself had been making the most of the relatively quiet night—destressing with some music and reading through hard copies of reports. Ever since a virus introduced by an offsite hacker had destroyed several computer records back in April, she’d been using slow nights like this one to rebuild files and rerun tests where there was still evidence available. She took pride in her team’s clean chain-of-evidence record, and it galled her to think that one happy hacker could throw a monkey wrench into what had previously been solid cases, forcing investigations to be delayed or even circumstantial corroboration to be tossed out of ongoing trials. It was a matter of professional pride for Holly to make those evidence reports right again. For the victims in those cases, it was a matter of justice.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But with Eli’s phone call, a much more personal stress had returned. She’d find a way to handle this one, too. Raking her fingers through her short, dark hair, she repeated her argument to her brother.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Jillian will be just fine. She came out of rehab a lot stronger than either of us expected, so you know that hardheaded Masterson gene is in her somewhere.” Eli had been worried about his other sister, not her, after all. “There’s no need for you and Shauna to cancel your holiday cruise. Between your job with the D.A.’s office and her responsibilities running KCPD, you two have never even had a honeymoon. And you’ve been married almost two years. Go. Have a merry Christmas. Not having to worry about our little sister is my gift to you.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But Eli wasn’t convinced. “It’s not Jillian who concerns me. If that Blake Rivers bastard is back in town, then you know he’s going to put pressure on her to get back together with him. I swear to God, Holl, after all those years with the drugs when we thought we might lose her, Jillian is finally on a healthy, positive track. She’s gone back to college. She’s volunteering with those kids at the youth center. If getting back with her old spoiled, party-time boyfriend knocks her off her game again…”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You’ll do what? You know, just because you’re not a cop anymore doesn’t mean you don’t have to follow the rules.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I didn’t follow them when I "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("was")])]), _vm._v(" a cop.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Holly tucked her long bangs behind one ear, nodding her head in wry agreement. Following the rules was one Masterson trait that was uniquely hers. “We have to give Jillian the chance to make her own decisions and then stand up to the consequences on her own. We can’t bulldoze in and take care of everything for her. That’d just be a form of co-dependency all over again.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The flicker of a shadow moved past the translucent glass door leading to the hallway, interrupting her thoughts and pacing. She "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("was")])]), _vm._v(" alone down here, wasn’t she? That’s why she’d dimmed the lights outside her office. No sense wasting the energy if she was the only one working in the lab. John Doe certainly didn’t need the light.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She stared hard at the clouded glass, waiting for the movement in the hallway to repeat itself. She wasn’t one to doubt what she’d seen, but she did like to have an explanation for things—be it an overnight cleaning staff employee coming in early, an electric short in one of the hallway lights, or even something as arcane as a ghost. She just wanted to know.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The glass darkened for an instant as the shadow passed by in the opposite direction.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Holly?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Jumping inside her skin at the prompt of Eli’s voice, she turned away from the distraction and focused on making her point. “You and Shauna need to get on that plane tomorrow and fly to Florida. Take your cruise. Enjoy it. Jillian needs to be the one to tell Blake where to get off if he tries to rekindle a relationship she’s not interested in.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“What if she "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("is")])]), _vm._v(" interested? What if Rivers won’t take no for an answer? I’ll be a thousand miles away.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You’ll be right where you should be. With your wife.” Holly circled around behind her desk, double-checking the duty log and silently accounting for all the staff and techs scheduled to be in the building at this hour. “I can look out for Jillian. And I’ll handle Blake, too, if he causes trouble.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I always could count on you to be the sensible one.” Some of the tension eased from Eli’s voice and she could imagine him smiling. “All right. I’ll go. I’ll have my phone, though. If you need anything, call me.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No. I won’t. If something comes up, I’ll take care of it myself.” With one part of her brain still marking off people she’d seen in their labs, offices or the break room, Holly tried to put her brother completely at ease. He had a honeymoon to get to, after all. “I appreciate your concern, but I’m a big girl. So is Jillian. The two of us have already planned to have Christmas dinner and exchange gifts. We’ll be fine. Have a wonderful trip. Put on some sunscreen and give my love to Shauna.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Eli hesitated for a moment, but ultimately, he gave in. “You’re sure?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Positive.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“All right. I’ll do my best to enjoy some quality time alone with my gorgeous wife.” Holly smiled as she was meant to and he continued, “Love you, sis.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Though she suspected he’d leave his phone on 24/7—just in case—he conceded that at thirty-five, with a doctor’s degree and a demanding job, she was a big enough girl to handle herself and their sister’s ex-boyfriend if need be. “Love you, too, Eli. Bon voyage.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("After hanging up, Holly checked the clock on the wall in her office. A few minutes past midnight. Time to shut things down and head out.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But though she turned off her computer and locked up the hard copies of the files she’d had out, Holly Masterson wasn’t about to leave her lab until the mystery of the out-of-place shadow was resolved. She turned on her cell phone in case Jillian called and dropped it into her lab coat pocket. After closing the office door behind her, she flipped on the lights and ventured out into the bright, chilly sterility of the lab. Pausing only to turn off the colored lights on the miniature artificial Christmas tree she’d set on one of the stainless steel counters, she made a quick circle around the empty room, peeked in on John Doe in his drawer, then headed for the hallway door.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("There, she turned off all the interior lights again and waited. If there was a short in one of the hall sconces that was going on and off and creating the illusion of shadows, it would be easy to spot from this vantage point. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Wait for it. Wait for it")])]), _vm._v(". “Hmm. No problem with the lights.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Checking that possibility off her list, she opened the door a crack and listened for sounds. No ding of the elevator’s bell, no whir of it rising on its cables and pulleys. No footsteps. Nothing beyond the endless whoosh from the heating vents, trying to warm up the common areas of the building to a more humane environment than the cooler temps used in the labs. So she "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("was")])]), _vm._v(" alone. Unwilling to give much credence to the ghost theory, Holly deduced that someone had walked past the door—twice—while she’d been on the phone with Eli. Someone who was lost because her lab, office and the autopsy room were the only destinations on this level. Yet no one had come in. Asked for directions. Shown up to ID the body in her morgue. So, who would be wandering through the basement at this time of night?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("No one, apparently. It was probably the late hour that had her spooked. “Give it a rest, girl.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Ignoring the twinge of annoyance that she couldn’t solve a simple mystery, Holly pulled the door shut behind her and jogged up the stairs to the first floor. The stairwell proved empty as well, and since she hadn’t heard the elevator moving, there was no sense looking there. She nodded to the guard manning the reception desk on her way to the locker rooms at the rear of the building. But the need to find an answer just wouldn’t go away.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Holly fisted her hands inside the pockets of her white coat and turned back to the guard. “Floyd? Did you see anyone going down to the basement? Within the last ten minutes or so?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He looked up from the paper he was reading. “No, ma’am. No one’s been in or out the lobby for the past hour. The cleaning crew’s not set to come until one.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“None of the guards were making rounds downstairs, were they?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Not that I know of. Is there a problem, Doctor?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Holly shook her head and smiled. “I thought I saw someone down there, but no one checked in with me at my office.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Floyd reached for his cap. “Would you like me to run down and sweep for an intruder?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No, no.” She waved him back to his seat. “There are only so many ways to get in or out of the basement, and if you didn’t see anyone on the elevator or the stairs…?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He wrinkled up his forehead with an apology. “Not for the past hour, ma’am. Not until you came out that door just now.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Okay. Well, maybe I just imagined the company.” She didn’t quite believe that, but without any evidence or witnesses to the contrary, there was nothing to do but go home. “Good night, Floyd. I’ll see you tomorrow.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Good night, ma’am.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Once inside the locker room, Holly shed her lab coat and hung it inside her locker. Since she’d already traded her surgical blues for warm jeans and a turtleneck sweater after completing John Doe’s autopsy, changing for the drive home only meant bundling up for the winter weather outside. Pushing aside the gun and holster she wore on field calls, Holly pulled her teal-green stocking cap and matching scarf from the top shelf.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Once she had her coat buttoned up, she turned on the blinking red nose of the Rudolph pin at her lapel. The gaudy reindeer jewelry was a testament to her late mother, who’d loved to decorate and celebrate the holidays in a big way. Her parents had been gone for fifteen years, her family fractured. But over the years, she’d grown closer to Eli and Jillian than they’d ever been as children. Now, instead of missing her parents, she paid homage to them by maintaining some of their happiest—and goofiest—traditions. Touching the pin and feeling a loving smile from somewhere in Heaven, Holly grabbed her purse and gloves and headed for the exit.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("If she was lucky, the streets would be cleared, the traffic would be light and she could get home to her apartment and get some decent sleep before she had to report for work again in the morning.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She had just pulled one glove on when her cell phone rang. Surely Eli wasn’t calling for another round of how she and Jillian couldn’t survive without big brother in the house.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Reaching into her purse, she pulled out her phone. The same familiar word instead of a number stared back at her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Unnamed")])]), _vm._v(".")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Okay, fella.” Breathing out a weary sigh, Holly opened the phone. “Hello?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Nothing. But the connection was live. She could hear the faint hiss of shallow breathing in the background.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Hey. I know you’re there. You have the wrong number. You need to stop calling me.” More silence. Not even so much as a suggestive or crude message if that was his intent. Just…someone listening. “Who is this?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Click")])]), _vm._v(".")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She jerked the phone from her ear as if the soft disconnect had been a zap of static electricity.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("What the hell kind of psych game was this? Holly snapped the phone shut and dropped it into her purse as she pushed open the door to the main hallway. “Idiot.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A blur of white lunged at her from around the corner. “Gotcha!”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Holly yelped, automatically punching at the man who’d startled her while her heart was already thumping in her chest. “Damn it, Rick!”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Guffaws of deep-pitched laughter faded into a wide toothy grin on Rick Temple’s clean-shaven face. “Oh, that one was priceless. If you could see your expression.” He rubbed at a spot on his shoulder. “But you’ve got a mean punch, Doc.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Talk about idiots. How one man could know so much about forensic science and yet beans about interacting with people in a mature, normal way eluded her. “What are you, in junior high? Sorry about the bruise, but startling the crap out of me is not funny.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Depends on your perspective.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Holly flashed a grin that was more of a sneer than sincere.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You’re a grown man. One of these days you’re going to have to start acting like one. These practical jokes are hard on my blood pressure.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Oh, but you make it too easy, lady. Walking around all serious, focused all the time. I’ve got to lighten you up.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Giving me gray hairs isn’t the kind of lightness I find amusing.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You’re not that old, Doc. You’ve got to start having some fun.” At least he had the decency to retrieve the glove she’d dropped. She knew him to be thirty-two years old, but the grin he still wore looked two decades younger as he handed over the glove. “Think of these little encounters as my way of keeping you on your toes.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Did he think she wasn’t doing her job? The corrupted evidence files she’d been trying to re-create made her prickle a little more defensively than usual. Not for the first time, she wondered how much of Rick’s teasing was really a warped sense of humor and how much might be resentment that "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("she’d")])]), _vm._v(" gotten the supervisory job that they’d both applied for. It might be wise for her to remind him who was in charge. “You know, Rick, if you weren’t as good at your job as you are, I might have to write you up for your…personality quirks. If any of your jokes interfere with anyone’s ability to do their job…”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Oh, good one, Doc. Flatter me and call me out, all in the same sentence.” He pulled back the front of his lab coat and shoved his fingers into the front pockets of his jeans. “I just wanted to catch you before you left and let you know that the preliminary report on that bullet I’m processing doesn’t look promising. I’ve been able to break it down into its components, and maybe even tell you how they’re decomposing so quickly. But pull a manufacturer’s name off it? Even at a microscopic level, I haven’t been able to pull anything substantive off the casing.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Good. Fortunately, he could be serious when he talked about work. “Any luck with the caliber?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’m guessing a thirty-five mil. I should be able to give you something definitive by the morning.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Holly was breathing normally now. Her smile was genuine. And another possibility regarding the mysterious shadow had presented itself. “Thanks, Rick. Say, were you down in the basement a few minutes ago, trying to catch me with your update? I was on the phone, but you could have come in.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No.” As her humor returned, his faded. “I just now came down from the ballistics lab. Are you checking on me every moment of every shift now? Or do you just miss working side by side with me?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“We still have plenty of opportunities to work together. I thought someone might be looking for me, that’s all. Thanks. I’ll look forward to that full report.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“First thing in the morning, I promise. You headed out?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She nodded. “I’m done for the night. See you at seven?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’ll be here.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Good night.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Boo.” He flashed his hands in her face, startling her slightly. “Too easy. Just too damn easy.” Rick’s chuckle disappeared with him into the men’s locker room.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Shaking her head, Holly pulled on her remaining glove and turned toward the exit to the parking garage.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Nine nights out of ten, Holly enjoyed working the late shift. With a few juvenile colleague exceptions, she preferred the quiet and solitude of the nighttime hours. Dealing with fewer people meant she could concentrate on her work. Dissecting bodies and processing biological evidence tended to have an isolating effect in the first place, but the calm and quiet and focus on the job were what allowed her to deal with crime scenes that could often be gruesome, and victims who were always some form of tragic. Having to deal with the victim’s family or witnesses on top of the crime itself could be draining.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Yet tonight she couldn’t seem to settle inside her skin.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Holly pushed open the thick steel door that led from the lab building into the attached parking garage. The heels of her boots grated against the concrete as she strode to her car, the abrasive grinding of soles and grit echoing off the walls of the garage. There was an edginess crawling through her veins, and despite knowing she’d be reporting to help with a double-shift in the morning, she was beginning to think she wasn’t going to be getting much sleep tonight.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She didn’t know if it was the unexplained shadow or the pesky anonymous phone calls that had her so off-kilter. Maybe it was Rick’s eternal pleasure at getting a rise out of her or the conversation she’d had with Eli. No doubt it was a combination of all those things that made her so uneasy.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lengthening her stride, she hurried past cars and trucks and empty parking slots. She pulled her keys from her purse and squeezed her fist tighter around the shoulder strap. Chances were, she was subconsciously preparing herself for another surprise from Rick.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("That’s why, when she heard a car door open, she didn’t immediately panic. Enough was enough. If he wanted to keep playing these games, then she would chew him up one side and down the other like the immature child he was.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Only, that was no child climbing out of the black Jeep next to her Honda. And it wasn’t Rick.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Holly stopped. Stared. Retreated a step as a dark-haired man slowly unfolded himself from behind the wheel.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Rick Temple was merely annoying. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("This")])]), _vm._v(" guy made her curl her toes inside her socks and brace for trouble.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("When she wore her high-heeled boots, Holly stood six feet tall. This guy was taller. Broader. The brass tip of a cane clacked against the concrete, drawing her attention down to the ground for a split second. When the car door closed, her gaze darted back up to collide with eyes that were gray and hooded and cold like steel. The late-night shadow of his beard was scraggly and dark and added an air of menace to his square jaw and angular features. Despite the cane, he moved from the shadows with a deliberate grace and Holly instinctively backed away.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Dr. Masterson?” His gritty voice was deep in pitch, but hoarse, as though a cold had settled in his throat.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He knew her name? “Yes?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Was that her pulse hammering in her ears? Or warning drums thundering inside her head?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The gray eyes cut right to the truth. “Don’t be afraid of me.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Impossible")])]), _vm._v(".")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I need to talk to you.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("This man was no shadow.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("And he was no practical joke.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dab5d11","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/kansascitychristmas_ch02.vue
// module id = 81
// module chunks = 0